import React from "react";
import LandingPage from "./LandingPage";

// Root (`/`) is always the public SEUTRADE FINANCIAL SERVICES cover / landing page
// (with Admin / Borrower / Broker sign-in entry points). The authenticated
// internal workbench lives at /workbench behind admin auth.
export default function RootGate() {
  return <LandingPage />;
}
